import { Box, Icon } from "@mui/material";

import Keycap from "~/components/keyboard/Keycap";
import { CaptionText } from "~/components/Typographies";
import useHintBadgeMode from "~/hooks/useHintBadgeMode";
import useKeybindingOverrides from "~/hooks/useKeybindingOverrides";
import hintBadgeBinding from "~/keyboard/hintBadgeBinding";
import useShortcut from "~/keyboard/useShortcut";

const HintBadgeMode = () => {
	const { enabled, setEnabled, toggle } = useHintBadgeMode();
	const { overrides } = useKeybindingOverrides();

	useShortcut("hintBadges.toggle", () => {
		toggle();
		return true;
	});

	useShortcut(
		"hintBadges.exit",
		() => {
			setEnabled(false);
			return true;
		},
		{ enabled }
	);

	if (!enabled) return null;

	const toggleBinding = hintBadgeBinding("hintBadges.toggle", overrides);

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: "primary.main",
				borderRadius: 100,
				boxShadow: 4,
				color: "primary.contrastText",
				display: "flex",
				gap: 1,
				left: "50%",
				position: "fixed",
				px: 2,
				py: 0.75,
				top: 12,
				transform: "translateX(-50%)",
				zIndex: (theme) => theme.zIndex.snackbar
			}}
		>
			<Icon sx={{ fontSize: "1.05rem" }}>keyboard</Icon>
			<CaptionText sx={{ color: "primary.contrastText" }}>Keyboard hints on</CaptionText>
			<CaptionText sx={{ color: "primary.contrastText", opacity: 0.85 }}>Press Esc to hide</CaptionText>
			{toggleBinding && <Keycap binding={toggleBinding} />}
		</Box>
	);
};

export default HintBadgeMode;
